/*

ashraf 09/29/2022  2698948956 fixed bugs on add custom window
ashraf 11/09/2022  2698948956 fetching type code dropdown options
Ashraf 11/28/2022 2698948956 added reducers for save, get custom window
Ashraf 11/30/2022  2698948956 changed url for udw
Ashraf 11/30/2022 2698948956 changed url's for usage
Ashraf 12/01/2022 2698948956 changed url's for delete custom window.
Ashraf 12/01/2022 2698948956 added added reducer for fetching window details for validation
Ashraf 12/05/2022  2698948956 fixed error message issue
Dilip 12/05/2022  2698948956 Removed unecesarry console.log statements
Ashraf 12/06/2022  2698948956 changed success message
Ashraf 12/22/2022 2698948956 changed get custom window Api payload
Akhila 01/10/2023 2698948956 removed unwanted lookUp api
Sohel 06/12/2023 3031593925 Fixed Custom Window Reset Issue
Ravi 06/26/2023 2698948956 fixed submit issue
Ravi 06/26/2023 2698948956 fixed submit disable issue
*/

import { createSlice } from '@reduxjs/toolkit';
import { httpGet, httpPost } from '../../util/Rest';
import { deleteWorkQueueByAccountNumber } from './WorkQueue';
import { submissionEnd } from './CommonActions/commonActions';
import {
  clearWindowError,
  deleteModifiedWindowSessionItem,
  removeModifiedWindow,
} from './ModifiedWindows';

const initialData = {
  udwData: {},
  udwFormData: {},
  udwStatus: null,
  udwFormStatus: null,
  isLoading: false,
  errorMsg: null,
  lookupValues: [],
  successMsg: null,
  dbRefData: [],
  isDBRefsLoading: null,
  windowDeleteStatus: null,
  windowDeletionLoading: null,
  windowDeletionError: null,
  fieldDeleteStatus: null,
  fieldDeletionLoading: null,
  fieldDeleteFromDBStatus: null,
  fieldDeleteFromDBMessage: null,
  windowValidationDeleteStatus: null,
  WindowDeletesuccessMsg: null,
  typeCodeDropdownData: {},
  dropDownData: [],
  customWindowData: {},
  allWindowData: {},
};

const slice = createSlice({
  name: 'udw',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    deletionStart: (state) => {
      state.windowDeletionLoading = true;
      state.errorMsg = null;
    },
    getDeleteResponse: (state, action) => {
      state.windowDeleteStatus = action.payload.status;
      state.WindowDeletesuccessMsg = action?.payload?.response;
      state.windowDeletionLoading = false;
      state.errorMsg = null;
    },
    getDeleteValidationResponse: (state, action) => {
      state.windowValidationDeleteStatus = action?.payload?.status;
      state.errorMsg = action?.payload?.message;
      state.windowDeletionLoading = false;
      state.successMsg = null;
    },
    getUDWData: (state, action) => {
      state.udwData[action?.payload?.window?.windowId] = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getCustomWindowData: (state, action) => {
      state.customWindowData = action.payload.response;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postUDWData: (state, action) => {
      state.udwStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action?.payload?.response;
    },
    getUDWFormData: (state, action) => {
      state.udwFormData[action?.payload?.windowId] = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchLookupData: (state, action) => {
      state.lookupValues = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postUDWFormData: (state, action) => {
      state.udwFormStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = 'Data Saved Successfully';
    },
    deleteSuccess: (state, action) => {
      console.log(action, 'aaaaaaaaaaaaaaaaaaaa');
      state.udwFormStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action?.payload?.response;
    },
    fieldDeleteCheckResponse: (state, action) => {
      state.fieldDeleteStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
      state.fieldDeletionLoading = false;
    },
    fieldDeleteResponse: (state, action) => {
      state.fieldDeleteFromDBStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.fieldDeleteFromDBMessage = action.payload.response;
    },
    postDbRefData: (state, action) => {
      state.dbRefData = action?.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.isDBRefsLoading = false;
    },
    postRepoFields: (state, action) => {
      state.udwStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action?.payload?.response;
    },
    getTypeCodeData: (state, action) => {
      state.typeCodeDropdownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getWindowData: (state, action) => {
      state.allWindowData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetDbRef: (state) => {
      state.dbRefData = [];
    },
    fieldDeletionStart: (state, action) => {
      state.fieldDeletionLoading = true;
    },
    resetUDWFormData: (state, action) => {
      state.udwFormData = {};
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.message
        ? action?.payload?.data?.message
        : action?.payload?.data?.error
          ? action?.payload?.data?.error
          : action?.payload?.statusText
            ? action?.payload?.statusText
            : action?.payload
              ? action?.payload
              : '';
      state.isLoading = false;
      // state.udwData = {};
      state.windowDeletionLoading = false;
      state.fieldDeletionLoading = false;
    },
    fetchGetUDWError: (state, action) => {
      state.errorMsg = action?.payload;
      state.udwData = {};
    },
    resetMsg: (state) => {
      state.udwFormStatus = null;
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.windowDeletionLoading = false;
      state.fieldDeleteMessage = null;
      state.fieldDeleteFromDBMessage = null;
      state.WindowDeletesuccessMsg = null;
    },
    resetUdw: (state) => {
      state.udwStatus = null;
      state.windowDeleteStatus = null;
      state.fieldDeleteStatus = null;
      state.fieldDeleteFromDBStatus = null;
      state.windowValidationDeleteStatus = null;
    },
    resetData: (state, action) => {
      state.customWindowData = {};
    },
  },
});

export default slice.reducer;

// Actions

const {
  getUDWData,
  postUDWData,
  fetchStart,
  fetchError,
  fetchGetUDWError,
  resetMsg,
  getUDWFormData,
  postUDWFormData,
  resetUdw,
  fetchDropDownData,
  getTypeCodeData,
  postDbRefData,
  resetDbRef,
  fieldDeletionStart,
  deletionStart,
  fieldDeleteResponse,
  fieldDeleteCheckResponse,
  getDeleteResponse,
  getDeleteValidationResponse,
  postRepoFields,
  getCustomWindowData,
  resetData,
  getWindowData,
  deleteSuccess,
  resetUDWFormData,
} = slice.actions;

export const getUDW = (windowCode, accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`custom/window/get/${windowCode}`)
      .then((data) => {
        if (data?.status === 200) {
          dispatch(getUDWData(data?.response));
        } else if (data && data?.status === 500) {
          dispatch(fetchError(data));
        } else {
          dispatch(fetchError(data?.message));
          dispatch(fetchGetUDWError(data?.data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const postUDW = (data, isUpdate) => {
  const url = isUpdate === 'update' ? `udw/admin/update` : `udw/admin/save`;
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${url}`, data)
      .then((data) => {
        dispatch(submissionEnd());
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postUDWData(data));
        } else if (data && data.status === 500) {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getUDWForm = (payload) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`custom/window/get/custom-window-data`, payload)
      .then((data) => {
        if (data.status === 500) {
          dispatch(fetchError(data));
        } else if (data.status === 200) {
          const last = data?.response ? data?.response : {};
          last['windowId'] = payload?.windowId;
          dispatch(getUDWFormData(last));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postUDWForm = (payload, windowCode,windowName) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`custom/window/save/custom-window/data/${windowCode}`, payload) // custom/window/save/custom-window/data/{windowName}
      .then((data) => {
        if (data.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data.status === 200) {
          dispatch(
            deleteWorkQueueByAccountNumber({
              accountNumber: payload?.account_number,
              isDirty: true,
            }),
          );
          dispatch(postUDWFormData(data));
          deleteModifiedWindowSessionItem(windowName);
          dispatch(
            removeModifiedWindow({
              windowName: windowName,
            })
          );
          dispatch(
            clearWindowError({
              windowName: windowName,
            })
          );
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const FieldDeletionCheck = (data, windowCode) => {
  return (dispatch) => {
    dispatch(fieldDeletionStart());
    httpPost(`data-repository/validate/data-repository/field`, data)
      .then((data) => {
        if (data.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data.status === 200) {
          dispatch(fieldDeleteCheckResponse(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const DeleteField = (data, windowCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`udw/admin/delete/udw/field`, data)
      .then((data) => {
        if (data.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data.status === 200) {
          dispatch(fieldDeleteResponse(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

// export const fetchLookupValues = () => {
//   return (dispatch) => {
//     dispatch(fetchStart());
//     httpGet(`udw/getall/windowlookup`)
//       .then((data) => {
//         if (data && data.status && data.status === 200) {
//           dispatch(fetchLookupData(data.response));
//         } else {
//           dispatch(fetchError(data.message));
//         }
//       })
//       .catch((error) => {
//         dispatch(fetchError(error.message));
//       });
//   };
// };

export const WindowValidationDeletion = (data) => {
  return (dispatch) => {
    dispatch(deletionStart());
    httpGet(`custom/window/validate/custom-window/${data?.windowId}`)
      .then((data) => {
        if (data.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data.status === 200) {
          dispatch(getDeleteValidationResponse(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const WindowDeletion = (data) => {
  return (dispatch) => {
    dispatch(deletionStart());
    httpPost(`custom/window/delete/${data?.windowId}`)
      .then((data) => {
        if (data.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data.status === 200) {
          dispatch(getDeleteResponse(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postDbRef = (data) => {
  return (dispatch) => {
    httpPost(`udw/admin/search/globalfield`, data)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(postDbRefData(data.response));
        } else {
          dispatch(fetchError(data?.response?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchTypeCodeData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lookup/findall/typecodeanddescription`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getTypeCodeData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchwindowNameData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`custom/window/find/all/custom-window/code`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getWindowData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getLookUpData = (typeCode, array) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: array && array === 'array' ? typeCode : [typeCode],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0]?.data ? data[0].data : null;
        if (lookUpApiData && Object.keys(lookUpApiData).length > 0) {
          dispatch(fetchDropDownData(lookUpApiData));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postRepoFieldsUDW = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`custom/window/save/custom-window`, data)
      .then((data) => {
        dispatch(submissionEnd());
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postRepoFields(data));
        } else if (data && data.status === 500) {
          dispatch(fetchError(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchCustomWindowData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`custom/window/find/custom-window/${id}`)
      .then((data) => {
        if (data.status === 200) {
          dispatch(getCustomWindowData(data));
        } else if (data && data.status === 500) {
          dispatch(fetchError(data));
        } else {
          dispatch(fetchError(data.message));
          dispatch(fetchGetUDWError(data.data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const deleteMultiRecord = (data) => {
  return (dispatch) => {
    httpPost(`custom/window/delete/multirecord/data`, data)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(deleteSuccess(data));
        } else {
          dispatch(fetchError(data?.response?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const resetDbRefData = () => {
  return (dispatch) => {
    dispatch(resetDbRef());
  };
};

export const resetToast = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetUdwStatus = () => {
  return (dispatch) => {
    dispatch(resetUdw());
  };
};

export const resetWindowData = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};

export const resetUDWForm = () => {
  return (dispatch) => {
    dispatch(resetUDWFormData());
  };
};
